import React from 'react';
import { Circle } from 'react-circle';

import { getTailwindColor } from '@trqk/utils';

import { IconMusicFile } from '../icons';

const progressColor = getTailwindColor('secondary-500');
const progressBgColor = getTailwindColor('tertiary-200');

interface Props {
    progress: number;
}

export const MusicFileProgressCircle = ({ progress }: Props): JSX.Element => (
    <div className="relative">
        <Circle
            progress={progress}
            size="35"
            lineWidth="55"
            progressColor={progressColor}
            bgColor={progressBgColor}
            showPercentage={false}
        />
        <span
            className="absolute"
            style={{
                top: 6,
                left: 9,
            }}
        >
            <IconMusicFile fillColor="primary-500" width={18} />
        </span>
    </div>
);
